import { getLocale } from './localeConfig';

type PluralCategory = 'zero' | 'one' | 'two' | 'few' | 'many' | 'other';
type PluralForms = Partial<Record<PluralCategory, string>>;

// Locale-aware pluralization based on the active locale's CLDR rules.
//
// Mirrors the Lingui `plural` macro: pass the forms keyed by CLDR category
// (`one`, `other`, ...) and use `#` as the count placeholder; missing
// categories fall back to `other`.
//
// We rely on the native Intl.PluralRules (the same engine Lingui uses under
// the hood) rather than the Lingui macro because the shared package is
// intentionally i18n-framework-free (Intl only, like dateFormatters/
// numberFormatters), and its source is esbuild-prebundled by the web app,
// which would skip the Lingui macro transform at build time.
export const pluralize = (count: number, forms: PluralForms) => {
  const category = new Intl.PluralRules(getLocale()).select(count);
  const form = forms[category] ?? forms.other ?? '';
  return form.replace(/#/g, String(count));
};
